import React from 'react';

import RegisterLoginButtons from 'modules/Common/components/RegisterLoginButtons';

export default function MyStableUnauthenticatedUser() {
  require('./MyStableUnauthenticatedUser.scss');

  return (
    <div>
      <section className="my-stable-unauthenticated-user">
        <h3 className="section-title">Never Miss the Kick Again</h3>
        <p className="section-subtitle">My Stable is FREE! Never miss a horse running again.</p>

        <p>Let My Stable send you an e-mail to tell you:</p>

        <ul className="my-stable-benefits">
          <li>
            The night before any horse you’ve added to your stable runs in the UK or Ireland or any of your trainers and jockeys have declared runners. This is all part of your free subscription.
          </li>
          <li>
            Our fully automated database of all horses in training in the UK and Ireland will effortlessly assist you in setting up your stable of horses while we're also giving you the opportunity of staying on top of entries and runners from your favourite stables and jockeys.
          </li>
        </ul>

        <p>By registering you’ll also receive access to our complete video form archive and have the ability to receive notifications of race results and/or football goalflashes direct to your phone. This unrivalled service is available completely free-of-charge on sportinglife.com.</p>
        <br/>

        <RegisterLoginButtons />
      </section>
    </div>
  );
}




// WEBPACK FOOTER //
// ./modules/HorseRacing/components/MyStableUnauthenticatedUser.js